import { useEffect, useState } from 'react';
import { AppFormSection } from '../../../../../../ui/AppFormSection';
import { formatExternalPrefillIdsForInput, parseExternalPrefillIdsFromInput } from '../DraggableFormRow/lib/external-prefill-ids';

const toInputValue = value => formatExternalPrefillIdsForInput(parseExternalPrefillIdsFromInput(value));

/**
 * Prefill codes are stored as a parsed list, which has no room for the comma typed on the way to the next code.
 * The raw text therefore lives here and is replaced only when the stored list really changes (undo, a loaded version).
 */
export function PrefillIdsInput({ value, onChange, label, disabled }) {
  const storedValue = formatExternalPrefillIdsForInput(value);
  const [inputValue, setInputValue] = useState(storedValue);

  useEffect(() => {
    setInputValue(current => (toInputValue(current) === storedValue ? current : storedValue));
  }, [storedValue]);

  const handleChange = event => {
    const nextValue = event.target.value;

    setInputValue(nextValue);
    onChange(parseExternalPrefillIdsFromInput(nextValue));
  };

  return (
    <AppFormSection
      formItemProps={{ style: { width: '100%' }, hasFeedback: false }}
      textFieldProps={{ value: inputValue, onChange: handleChange, label, disabled }}
    />
  );
}
